const config = {
    siteLanguageCode: "fi",
    noindex: false
}

export default config
